<template>
  <div class="main_content admin">
    <b-card no-body>
      <b-tabs pills card vertical class="mobile_hack_tabs">
        <b-tab title="手机号管理" style="padding:20px 50px;min-height: 400px;">
          <div class="filter_block" style="justify-content: space-between;">
            <div>
              <span>手机类型：</span>
              <b-form-radio-group style="display: inline-block; vertical-align: middle;"
                                  id="phonetype"
                                  v-model="phoneParams.type"
                                  :options="phoneTypeOptions"
                                  @change="submitPhoneType"
              ></b-form-radio-group>
            </div>
            <div>
              <button style="margin-right: 15px;" class="secondary_btn" @click="removePhone(selectedIds)">批量删除</button>
              <button class="primary_btn" @click="$modal.show('addPhoneModal')">新建</button>
            </div>

          </div>

          <table class="table table-striped table-responsive-sm table-hover green_table">
            <thead>
            <tr>
              <th>
                <b-link href="#" style="font-size: 12px; padding-right: 10px;" @click="selecteAll">全选</b-link>
                <b-link href="#" style="font-size: 12px;" @click="shift">反选</b-link>
              </th>
              <th scope="col">id</th>
              <th scope="col">手机号</th>
              <th scope="col">市县</th>
              <th scope="col">片区</th>
              <th scope="col">手机类型</th>
              <th scope="col">操作</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in phoneItems">
              <tr>
                <td>
                  <b-form-checkbox @click.native.stop style="display: flex;"
                                   v-model="selectedOption[index].selected"></b-form-checkbox>
                </td>
                <td>{{item.id}}</td>
                <td>
                  <b-form-input v-model="item.phone_num" type="number"/>
                </td>
                <td>
                  <b-form-select v-model="item.county_code" :options="countyCodeOption"
                                 @change="item.areaCodeOption = getAreaSelectData(item.county_code);"/>
                </td>
                <td>
                  <b-form-select v-model="item.area_code" :options="item.areaCodeOption"/>
                </td>
                <td>{{ item.phone_type ? '播放端' : '审核端'}}</td>
                <td>
                  <b-link @click.stop="modifyPhone(item)" style="padding-right: 15px;">修改</b-link>
                  <b-link @click.stop="removePhone([item.id])">删除</b-link>
                </td>
              </tr>
            </template>

            </tbody>
          </table>
          <AddPhoneModal @onSucess="getPhoneData(phoneParams)"/>
        </b-tab>
        <b-tab title="短信模板" style="position:relative;min-height: 400px;">

          <b-form class="middle sms_config_for_mobile" style="max-width: 500px;">
            <b-alert show variant="info"><span class="font-weight-bold">{{ msmItem.para1 }}（参数一）</span> 2019-04-06 <span
              class="font-weight-bold">  {{ msmItem.para2 }}（参数二） </span> 地点 <span class="font-weight-bold"> {{ msmItem.para3 }}（参数三）</span>
            </b-alert>
            <b-form-group
              id="input-group-1"
              label="参数一:"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="msmItem.para1"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2" label="参数二:" label-for="input-2">
              <b-form-input
                id="input-2"
                v-model="msmItem.para2"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-3" label="参数三:" label-for="input-3">
              <b-form-input
                id="input-3"
                v-model="msmItem.para3"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="是否时间前置" style="padding:0;">
              <b-form-radio-group id="radio-group-2" v-model="msmItem.is_time_front">
                <b-form-radio :value="0">否</b-form-radio>
                <b-form-radio :value="1">是</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <button class="primary_btn" @click="updateSMSTemplateItem(msmItem)">更新</button>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
  import { addPhone, deletePhone, getPhoneList, getSMSTemplate, updatePhone, updateSMSTemplate } from '@/api/phone'
  import AddPhoneModal from '@/components/AddPhoneModal'

  export default {
    data () {
      return {
        phoneParams: {
          type: 1,

        },
        selectedOption: [],
        locationOption: [],
        phoneTypeOptions: [ //0表示审核端，1表示播放端
          { text: '审核端', value: 0 },
          { text: '播放端', value: 1 }
        ],
        phoneItems: [],
        msmItem: {
          para1: '',
          para2: '',
          para3: '',
          is_time_front: null
        },
        selectedIds: []
      }
    },
    components: {
      AddPhoneModal
    },
    computed: {
      countyCodeOption () {
        let list = []
        this.$store.getters.county_code_list.forEach(item => {
          list.push({ text: item.name, value: item.code })
        })
        return list
      },
      areaCodeOption () {
        let list = []
        this.$store.getters.area_code_list.forEach(item => {
          list.push({ text: item.name, value: item.code })
        })
        return list
      },
      // selectedIds(){
      //   console.log('selectedIds --this.selectedOption',this.selectedOption)
      //   return this.selectedOption.map(v=>{ return v.id });
      // }
    },
    mounted () {
      this.getPhoneData(this.phoneParams)
      this.getSMSTemplateData()
    },
    methods: {
      getAreaSelectData (county_code) {
        return this.$store.getters.area_code_for_county[county_code].map(v => {
          return { text: v.name, value: v.code }
        }) || []
      },
      selecteAll () {
        _.forEach(this.selectedOption, (value, key) => {
          value.selected = true
        })
      },
      shift () {

        for (let i = 0; i < this.selectedOption.length; i++) {
          let _ob = Object.assign({}, this.selectedOption[i])
          _ob.selected = !this.selectedOption[i].selected
          // this.$set(this.selectedOption,i,_ob);
          // _option[i].selected = !this.selectedOption[i].selected;
          this.selectedOption.splice(i, 1, _ob)
        }
      },
      getPhoneData (data) {
        getPhoneList(data).then(resp => {
          this.phoneItems = resp.map(it => {
            return Object.assign(it, { areaCodeOption: this.getAreaSelectData(it.county_code) })
          })
          this.selectedOption = resp.map(it => {
            return { selected: false, id: it.id }
          })
        }).catch(error => {

        })
      },
      submitPhoneType (e) {
        this.getPhoneData({ type: e })
      },
      modifyPhone (items) {
        updatePhone(items).then(resp => {
          this.$toasted.global.pop_success('修改成功')
          this.getPhoneData(this.phoneParams)
        }).catch(error => {
          this.$toasted.global.pop_error('修改失败\n' + error)
        })
      },
      removePhone (items) {
        if (!items.length) {
          this.$toasted.global.pop_error('请选择要删除的数据')
          return
        }
        deletePhone({ ids: items }).then(resp => {
          this.$toasted.global.pop_success('删除成功')
          this.getPhoneData(this.phoneParams)
        }).catch(error => {
          this.$toasted.global.pop_error('删除失败\n' + error)
        })
      },

      getSMSTemplateData () {
        getSMSTemplate().then(resp => {
          this.msmItem = resp
        }).catch(error => {
        })
      },
      updateSMSTemplateItem (data) {
        updateSMSTemplate(data).then(resp => {
          this.$toasted.global.pop_success('更新成功')
        }).catch(error => {
          this.$toasted.global.pop_error('更新失败')
        })
      }

    },
    watch: {
      selectedOption: {
        handler: function (newValue, oldValue) {
          console.log('newValue', newValue)

          this.selectedIds = newValue.filter(v => {
            return v.selected
          }).map(it => {
            return it.id
          })
        },
        deep: true
      }
    },

  }
</script>
<style lang="scss" scoped>

</style>
